import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import React from "react";

import { Tooltip } from "@fronterahealth/frontera-ui-components";

export interface WarningTriangleProps {
  onClick: () => void;
  tooltipText: string | React.ReactNode;
  visible?: boolean;
}

export const WarningTriangle: React.FC<WarningTriangleProps> = ({ onClick, tooltipText, visible = true }) => {
  if (!visible) return null;

  return (
    <Tooltip text={tooltipText} showInfoIcon={false}>
      <button onClick={onClick} className="bg-white text-yellow-400">
        <ExclamationTriangleIcon className="h-12 w-12 pt-1" />
      </button>
    </Tooltip>
  );
};
